const { REACT_APP_API_ENDPOINT } = process.env;

/* export const URL_BASE =
  window.location.hostname === "localhost" && 
    ? "http://192.168.1.21:3030"
    : "https://api.camacolatlantico.org"; */
export const URL_BASE = `${REACT_APP_API_ENDPOINT}`;
export const URL_AUTHENTICATION = "/authentication";
export const URL_USER_INFO = "/current-user";
/* Algolia Access */
export const APPLICATION_ID = "BWKSA0TBZ5";
export const API_KEY = "fa953eb290e2a7ddf14512023e5e477c";
export const INDEX = "affiliates";
export const URL_EXPORT_EXCEL = `${URL_BASE}/public/excelList.csv`;

export const S3_INSTANCE_CAMACOL = "https://micamacol.s3.amazonaws.com/";
export const S3_INSTANCE_CONSTRUCARIBE =
	"https://construcaribe.s3.amazonaws.com/";

export const NO_IMAGE = `${S3_INSTANCE_CONSTRUCARIBE}assets/utils/image-not-found/logo-company.png`;
